import { render, staticRenderFns } from "./PriceDetails.vue?vue&type=template&id=0cab0c03&"
import script from "./PriceDetails.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PriceDetails.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cab0c03')) {
      api.createRecord('0cab0c03', component.options)
    } else {
      api.reload('0cab0c03', component.options)
    }
    module.hot.accept("./PriceDetails.vue?vue&type=template&id=0cab0c03&", function () {
      api.rerender('0cab0c03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PaymentInfo/components/PaymentClub/components/PriceDetails/PriceDetails.vue"
export default component.exports